import React, { useState } from "react";
import { Button } from "../../../../design/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../../design/dialog";
import { useAttorney } from "../../../../contexts/AttorneyContext";
import { CaseAttorney } from "@visitproof/types";

interface Props {
  assignment: CaseAttorney;
  attorneyName: string;
  onRemoved: () => void;
}

const RemoveAttorneyButton: React.FC<Props> = ({
  assignment,
  attorneyName,
  onRemoved,
}) => {
  const { removeAttorneyFromCase } = useAttorney();
  const [isOpen, setIsOpen] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async () => {
    setIsRemoving(true);
    try {
      await removeAttorneyFromCase(assignment.id);
      onRemoved();
      setIsOpen(false);
    } catch (error) {
      console.error("Error removing attorney:", error);
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <>
      <Button plain onClick={() => setIsOpen(true)}>
        Remove
      </Button>
      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Remove Attorney from Case</DialogTitle>
        <DialogDescription>
          Are you sure you want to remove {attorneyName} from this case? This
          action can be undone by re-assigning the attorney.
        </DialogDescription>
        <DialogBody />
        <DialogActions>
          <Button plain onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button color="red" disabled={isRemoving} onClick={handleRemove}>
            {isRemoving ? "Removing..." : "Remove"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveAttorneyButton;
